// Libraries
import React from 'react'
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from 'yup'

//Styles
import Progress from '../../components/Progress'
import { TextDescription, WrapFormContent } from '../StageOne/WrapFormContent'
import { Option, Select, WrapSelect } from '../../ui/Select'
import { Input } from '../../ui/Input/index'
import { Button } from '../../ui/Button'
import { ArrowLeft, TextButton } from '../../ui/TextButton'
import { MainWrapperWithCaptions } from '../../layouts/MainWrapperWithCaptions'

// Hooks
import { useForm } from 'react-hook-form'
import { ErrorText, WrapInput } from '../../ui/Input/style'

interface IProps {
  setStageAndToTop: (arg0: number) => void;
  onCredentialHandleSubmit: (arg0: object) => void;
  appendData: (arg0: object) => void;
  currentStage: number;
}

interface IFormInputs {
  firstName: string;
  lastName: string;
  title: number;
}

const SignupSchema = yup
  .object({
    firstName: yup.string().required('Dieses Feld ist erforderlich').matches(/^[A-Za-z]+$/i, 'Geben Sie den gültigen Namen ein'),
    lastName: yup.string().required('Dieses Feld ist erforderlich').matches(/^[A-Za-z]+$/i, 'Geben Sie den gültigen Namen ein'),
    title: yup.string().required('Dieses Feld ist erforderlich'),
  })
  .required();

export const StageTwo = ({ currentStage, setStageAndToTop, appendData  }: IProps) => {
  const { register: credentialsRegister, handleSubmit: credentialHandleSubmit, reset: credentialsReset, formState: { errors } } = useForm<IFormInputs>({
    resolver: yupResolver(SignupSchema)
  })

  const onCredentialHandleSubmit = (body: object) => {
    appendData(body)
    credentialsReset()
    setStageAndToTop(3)
  }
  return (
    <>
      <MainWrapperWithCaptions stage={currentStage}
                               title={<>Bitte gib uns noch<br /> Deinen Namen</>}
                               key={2}
                               textAlign='left'>
        <Progress stage={currentStage} />
      </MainWrapperWithCaptions>
      <WrapFormContent onSubmit={credentialHandleSubmit(onCredentialHandleSubmit)}>
        <WrapInput>
          <WrapSelect>
            <Select {...credentialsRegister('title')}>
              <Option value={1}>Frau</Option>
              <Option value={2}>Her</Option>
            </Select>
          </WrapSelect>
          <Input placeholder='Vorname*' {...credentialsRegister('firstName')} isError={errors?.firstName !== undefined} errorMessage={errors?.firstName?.message} />
          <Input placeholder='Nachname*' {...credentialsRegister('lastName')} isError={errors?.lastName !== undefined} errorMessage={errors?.lastName?.message} />
        </WrapInput>
        <TextDescription>*Morbi sed bibendum ut commodo lorem. Viverra malesuada sit sed ut amet quam mi.</TextDescription>
        <Button arrow>Weiter</Button>
        <TextButton onClick={() => setStageAndToTop(1)}>
          <ArrowLeft width="10" height="21" viewBox="0 0 10 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9 1L0.999999 10.5L9 20" stroke="white" strokeWidth="1.5"/>
          </ArrowLeft>
          Zurück
        </TextButton>
      </WrapFormContent>
    </>
  )
}